module.exports = __webpack_public_path__ + "img/imageLandingPreviewCaptureDevice@1x.0b29f424.png";